import api from '../../ApiConfig';
import { Apis } from '../../config';

import { Alerts } from '../index'

const uploadImage = async (data) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.UploadImages, data, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};


const getImages = async (limit, page) => {
    try {

        var token =  sessionStorage.getItem('userToken');

        let result = await api.get(`${Apis.GetImages}?page=${page}&limit=${limit}`, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};
const removeImage = async (id) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.RemoveImage + id, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const createImage = async (id, data) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.CreateImage + id, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            // Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return error;
    }
};

const fetchCreateImage = async (id) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.FetchCreatedImage + id, {
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const createImageProperty = async (data) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.CreateImageProperty, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const saveImageWithProperties = async (data) => {
    try {

        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.CreateImagePropertyOptions, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const removeImageProperty = async (data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.RemoveImageProperty,data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
    } catch (error) {
       
            Alerts.alertMessage(error.response.data, "Sorry !", "danger");
       
        return null;
    }
};

const getCreatedImage = async () => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetCreatedImages,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}

const deleteCreatedImage = async (id) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.DeleteCreatedImage + id,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}
const addImageProperyImage = async (data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.AddImagePropertyImage, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}

const saveCreatedImage = async (data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.SaveCreatedImage, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}

const addKeywordCreatedImage = async (data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.AddNewKeywordCreatedImage, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}
const deleteKeywordCreatedImage = async (id) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.DeleteKeywordCreatedImage + id,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
}

const exportedObject = {
    uploadImage,
    getImages,
    removeImage,
    createImage,
    fetchCreateImage,
    createImageProperty,
    saveImageWithProperties,
    removeImageProperty,
    getCreatedImage,
    deleteCreatedImage,
    addImageProperyImage,
    saveCreatedImage,
    addKeywordCreatedImage,
    deleteKeywordCreatedImage
};
export default exportedObject;